import { render, staticRenderFns } from "./seen-on-default.vue?vue&type=template&id=67c24f92&"
import script from "./seen-on-default.vue?vue&type=script&lang=js&"
export * from "./seen-on-default.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports